/* ------------------------------------------ RIGHT CONTEXT MENU - Chris 11.05.2016 ----------------------------------------- */
import store from '@/app/store/store';
import { atomLevel1, atomLevel2 } from '@/app/editor/sidebar/interactions/configs/atom.ts';
import { interactions } from '@/app/editor/sidebar/interactions/configs/interaction.ts';

(function (jQuery) {
  jQuery.gfContextMenu = function (element, options) {
    const defaults = {
      items: '.element-wrap, .module-wrap, .gf_column, .gf_row',
      hideAfterClick: true,
      activeClass: 'active',
      onItemClicked: function (key, $_targetMER) {},
    };
    this.settings = {};
    this.items = {};
    var $element = jQuery(element),
      element = element;

    const _this = this;

    let $_gfContextMenu;
    let $_targetMER;

    let _atTheBottom = true;
    let _atTheTop = true;
    let _hasParent = false;

    const $divTopBar = jQuery('#divTopBar');
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $gfContainer = jQuery('#gfContainer');

    const _interactions = interactions;
    const _atomLevel1 = atomLevel1;
    const _atomLevel2 = atomLevel2;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      if (this.settings.items) {
        this.items = $(this.settings.items);
      }
      // Create context menu
      if ($gryffBody.find('.gf_context-menu').length == 0) {
        $_gfContextMenu = jQuery('<div>').addClass('gf_context-menu').appendTo($gfContainer);
      }

      if (this.items) {
        $element.on('contextmenu', this.settings.items, $.proxy(this._contextMenu, this));
      } else {
        $element.on('contextmenu', $.proxy(this._contextMenu, this));
      }
    };

    this._contextMenu = function (e) {
      e.preventDefault();

      if ($_targetMER == undefined) {
        // find nearest MER
        const $target = jQuery(e.target);
        let data = _this.detectTargetType($target);

        if (jQuery.isEmptyObject(data)) {
          $target.parents().each(function () {
            const $parent = jQuery(this);

            data = _this.detectTargetType($parent);

            if (!jQuery.isEmptyObject(data)) {
              $_targetMER = $parent;
              return false;
            }
          });
        } else {
          $_targetMER = $target;
        }
        if ($_targetMER && !jQuery.isEmptyObject(data)) {
          if ($_targetMER.data('gfelement') != undefined) {
            $_targetMER.data('gfelement').showTool();
            _atTheBottom = $_targetMER.data('gfelement').atTheBottom();
            _atTheTop = $_targetMER.data('gfelement').atTheTop();
            _hasParent = $_targetMER.data('gfelement').hasParent();
          } else if ($_targetMER.data('gfmodule') != undefined) {
            $_targetMER.data('gfmodule').showTool();
            _atTheBottom = $_targetMER.data('gfmodule').atTheBottom();
            _atTheTop = $_targetMER.data('gfmodule').atTheTop();
            _hasParent = $_targetMER.data('gfmodule').hasParent();
          } else if ($_targetMER.data('gfrow') != undefined) {
            $_targetMER.data('gfrow').showTool();
            _atTheBottom = $_targetMER.data('gfrow').atTheBottom();
            _atTheTop = $_targetMER.data('gfrow').atTheTop();
            _hasParent = $_targetMER.data('gfrow').hasParent();
          }
        } else {
          return false;
        }

        // For Row, Column inside Product List we should not allow them to have context menu open
        if (
          data.label &&
          (data.label == 'Row' || data.label == 'Column') &&
          $_targetMER.closest('.module-wrap[data-label="Product List"]').length > 0 &&
          $_targetMER.closest('.module-wrap[data-label="Product"]').length == 0
        ) {
          // Reset $_targetMER
          $_targetMER = undefined;
          return false;
        }

        this._buildContextMenu(function () {
          $_gfContextMenu
            .find('.gf_c-item')
            .off('mousedown.context')
            .on('mousedown.context', function (e) {
              e.preventDefault();
              e.stopPropagation();

              const $this = jQuery(this);
              const key = $this.attr('data-action');

              if ($this.hasClass('gf_c-item-disabled') || $this.attr('data-action') == undefined) {
                return;
              }

              if ($_targetMER != undefined) {
                const parentId = $this.attr('data-id') != undefined ? $this.attr('data-id') : '';
                if (key != undefined) {
                  const itemClicked = $(this);
                  _this.settings.onItemClicked(key, $_targetMER, parentId, itemClicked);
                }
              }
              if (_this.settings.hideAfterClick) {
                _this.closeMenu();
              }
              return false;
            });

          _this.openMenu();

          const $gfFrameHtml = jQuery('html', $gfFrame.contents());
          let zoomOut = window._zoomOut != undefined ? window._zoomOut : 1;
          // var zoomOut = 1;
          let offset = (e.pageY + 15) * 1 + $divTopBar.height();
          if (offset + ($_gfContextMenu.height() - $gfFrameHtml.scrollTop()) * 1 > window.innerHeight) {
            offset = window.innerHeight + ($gfFrameHtml.scrollTop() - $_gfContextMenu.height()) * 1;
          }

          const contextTop = offset - $gfFrameHtml.scrollTop() * 1;

          $_gfContextMenu.css({
            top: contextTop + 'px',
            left: (e.pageX - $_gfContextMenu.width() / 2) * zoomOut + $gfFrame.offset().left + 'px',
            // 'transform': 'scale(' + zoomOut + ')',
            'transform-origin': 'top left',
          });

          /**
           * Calculate sub-menu of interaction item's position (drop-up or drop-down)
           */
          function calculateSubmenuPosition() {
            const $interaction = $_gfContextMenu.find('[gf-section="interaction"]');
            const $innerMenu = $interaction.find('.gf_context-menu');
            $innerMenu.css({
              top: '',
              bottom: '',
            });
            const ITEM_HEIGHT = 32;
            const itemCount = $innerMenu.find('.gf_c-item').length;
            const menuHeight = ITEM_HEIGHT * itemCount;
            const interactionOffset = $interaction.offset();
            if (!interactionOffset) {
              return;
            }
            const menuTop = interactionOffset.top;
            // if submenu bottom exceed viewport, display it from the bottom
            if (menuTop + menuHeight > window.innerHeight) {
              $innerMenu.css({
                top: 'unset',
                bottom: 0,
              });
            }
          }

          calculateSubmenuPosition();

          jQuery(window)
            .off('resize.contextmenu')
            .on('resize.contextmenu', function () {
              setTimeout(function () {
                zoomOut = window._zoomOut != undefined ? window._zoomOut : 1;
                // zoomOut = 1;
                // offset = (e.pageY + 15) * zoomOut + $divTopBar.height();
                offset = (e.pageY + 15) * 1 + $divTopBar.height();
                if (offset + ($_gfContextMenu.height() - $gfFrameHtml.scrollTop()) * 1 > window.innerHeight) {
                  offset = window.innerHeight + ($gfFrameHtml.scrollTop() - $_gfContextMenu.height()) * 1;
                }
                $_gfContextMenu.css({
                  top: offset - $gfFrameHtml.scrollTop() * 1 + 'px',
                  left: (e.pageX - $_gfContextMenu.width() / 2) * zoomOut + $gfFrame.offset().left + 'px',
                  // 'transform': 'scale(' + zoomOut + ')'
                });
                calculateSubmenuPosition();
              }, 100);
            });

          $gfFrame
            .contents()
            .off('scroll.contextmenu')
            .on('scroll.contextmenu', function () {
              $_gfContextMenu.css({
                top: offset - $gfFrameHtml.scrollTop() * 1 + 'px',
              });
              calculateSubmenuPosition();
            });
        });
      }
      return true;
    };

    this.buildMenuItem = function (name, action, shortcut, disabled, sections) {
      let item = '';
      let itemClass = '';
      if (disabled != undefined && disabled) {
        itemClass = 'gf_c-item-disabled';
      }
      let dataSection = '';
      if (sections && sections.length > 0) {
        dataSection = `data-sections="${sections.join('|')}"`;
      }
      item += `<div class="gf_c-item ${itemClass}" data-action="${action}" ${dataSection}>`;
      item += '<span class="gf_c-text">' + name + '</span>';
      if (shortcut != undefined && shortcut != '') {
        item += '<span class="gf_c-shortcut">' + shortcut + '</span>';
      }
      item += '</div>';

      return item;
    };

    this.detectTargetType = function ($_targetMER) {
      let data = {};
      if ($_targetMER.hasClass('element-wrap')) {
        data = {
          type: 'element-wrap',
          label: $_targetMER.attr('data-label'),
          id: $_targetMER.attr('id'),
        };
      } else if ($_targetMER.hasClass('module-wrap')) {
        data = {
          type: 'module-wrap',
          label: $_targetMER.attr('data-label'),
          id: $_targetMER.attr('id'),
        };
      } else if ($_targetMER.hasClass('gf_row') && $_targetMER.attr('data-label') == 'Row') {
        data = {
          type: 'gf_row',
          label: $_targetMER.attr('data-label'),
          id: $_targetMER.attr('id'),
        };
      }
      return data;
    };

    this._buildContextMenu = function (callback) {
      let label = 'Unknown';
      if ($_targetMER != undefined) {
        if ($_targetMER.hasClass('gf_column')) {
          label = 'Column';
        } else {
          label = $_targetMER.attr('data-label');
        }
      }

      const clipBoardCSS = this.getClipBoardCSS();
      let disabledCopyCSS = false;
      let disabledPasteCSS = true;
      if (!jQuery.isEmptyObject(clipBoardCSS) && clipBoardCSS.label == label) {
        disabledPasteCSS = false;
      }

      const menuArray = [];

      if ($_targetMER.hasClass('gf_row') || $_targetMER.hasClass('gf_column')) {
        if ($_targetMER.hasClass('gf_column')) {
          disabledCopyCSS = true;
          disabledPasteCSS = true;
        }
        menuArray.push({
          name: 'Edit Code',
          action: 'edit_code',
          shortcut: '',
          disabled: false,
          // sections: [
          //     {
          //         type: "template",
          //         disabled: true
          //     },
          //     {
          //         type: "style",
          //         disabled: false
          //     },
          //     {
          //         type: "script",
          //         disabled: true
          //     }
          // ]
          sections: ['style'],
        });
        menuArray.push({
          name: 'Copy Style',
          action: 'copy_css',
          shortcut: '',
          disabled: disabledCopyCSS,
        });

        menuArray.push({
          name: 'Paste Style',
          action: 'paste_css',
          shortcut: '',
          disabled: disabledPasteCSS,
        });
      } else if ($_targetMER.closest('.element-wrap').length > 0) {
        menuArray.push({
          name: 'Edit Code',
          action: 'edit_code',
          shortcut: '',
          disabled: false,
          // sections: [
          //     {
          //         type: "template",
          //         disabled: false
          //     },
          //     {
          //         type: "style",
          //         disabled: false
          //     },
          //     {
          //         type: "script",
          //         disabled: true
          //     }
          // ]
          sections: ['template', 'style'],
        });

        // menuArray.push({
        //     name: 'Edit HTML',
        //     action: 'template',
        //     shortcut: ''
        // })
        menuArray.push({
          name: 'Copy Style',
          action: 'copy_css',
          shortcut: '',
        });

        menuArray.push({
          name: 'Paste Style',
          action: 'paste_css',
          shortcut: '',
          disabled: disabledPasteCSS,
        });
      } else if ($_targetMER.closest('.module-wrap').length > 0 || $_targetMER.hasClass('module-wrap')) {
        menuArray.push({
          name: 'Edit Code',
          action: 'edit_code',
          shortcut: '',
          disabled: false,
          // sections: [
          //     {
          //         type: "template",
          //         disabled: false
          //     },
          //     {
          //         type: "style",
          //         disabled: false
          //     },
          //     {
          //         type: "script",
          //         disabled: false
          //     }
          // ]
          sections: ['template', 'style', 'script'],
        });

        // menuArray.push({
        //     name: 'Edit HTML',
        //     action: 'template',
        //     shortcut: ''
        // })
        menuArray.push({
          name: 'Copy Style',
          action: 'copy_css',
          shortcut: '',
        });

        menuArray.push({
          name: 'Paste Style',
          action: 'paste_css',
          shortcut: '',
          disabled: disabledPasteCSS,
        });
      } else if ($_targetMER.closest('.gf_column').length > 0) {
        menuArray.push({
          name: 'Edit Code',
          action: 'edit_code',
          shortcut: '',
          disabled: false,
          // sections: [
          //     {
          //         type: "template",
          //         disabled: true
          //     },
          //     {
          //         type: "style",
          //         disabled: false
          //     },
          //     {
          //         type: "script",
          //         disabled: true
          //     }
          // ]
          sections: ['style'],
        });
      } else if ($_targetMER.closest('.gf_row').length > 0) {
        menuArray.push({
          name: 'Edit Code',
          action: 'edit_code',
          shortcut: '',
          disabled: false,
          // sections: [
          //     {
          //         type: "template",
          //         disabled: true
          //     },
          //     {
          //         type: "style",
          //         disabled: false
          //     },
          //     {
          //         type: "script",
          //         disabled: true
          //     }
          // ]
          sections: ['style'],
        });
      } else {
        return false;
      }

      // find parents
      const parents = [];
      const data = _this.detectTargetType($_targetMER);
      if (!jQuery.isEmptyObject(data)) {
        parents.push(data);
      }
      $_targetMER.parents().each(function () {
        const $parent = jQuery(this);
        const data = _this.detectTargetType($parent);
        if (
          data.label &&
          (data.label == 'Row' || data.label == 'Column') &&
          $parent.closest('.module-wrap[data-label="Product List"]').length > 0 &&
          $parent.closest('.module-wrap[data-label="Product"]').length == 0
        ) {
          return;
        }
        if (!jQuery.isEmptyObject(data)) {
          parents.push(data);
        }
      });

      let item = '<div class="gf_c-section">';
      item += '<div class="gf_c-item">';
      item += '<span class="gf_c-text"><span>' + label + '</span></span>';
      item +=
        '<div class="gf_c-caret" style="display: flex; align-items: center;"><svg width="6" height="9" viewBox="0 0 6 9" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M5 4.5L1 8V1z"></path></svg></div>';

      if (parents.length > 0) {
        parents.reverse();
        item += '<div class="gf_context-menu">';
        item += '<div class="gf_c-section">';

        for (let p = 0; p < parents.length; p++) {
          item += '<div class="gf_c-item" data-action="settings" data-id="' + parents[p].id + '">';
          item += '<div class="gf_c-item-icon">';
          if (p == parents.length - 1) {
            item +=
              '<svg width="13" height="11" viewBox="0 0 13 11" class="bem-Svg " style="display: block; transform: translate(0px, 0px); margin: auto;"><path fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" d="M11 2L5.5 8.5 2 5"></path></svg>';
          }
          item += '</div>';
          item += '<div class="gf_c-item-body">';
          item +=
            '<div style="display: grid; grid-template-rows: 19px; grid-template-columns: auto auto; grid-template-areas: none; line-height: 1; gap: 8px 8px; align-items: center;">';

          switch (parents[p].type) {
            case 'gf_row':
              item +=
                '<span><svg width="13" height="12" viewBox="0 0 13 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M11 1H1v10h11V1h-1zm0 9H2V2h9v8zM5 9h1V3H3v6h2zM4 4h1v4H4V4zm5 5h1V3H7v6h2zM8 4h1v4H8V4z"></path></svg></span>';
              break;

            case 'gf_column':
              item +=
                '<span><svg width="13" height="12" viewBox="0 0 13 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M1 1v10h5V1H1zm4 9H2V2h3v8zm6-9H7v10h5V1h-1zm0 9H8V2h3v8z"></path></svg></span>';
              break;

            case 'module-wrap':
              switch (parents[p].label) {
                case 'Icon List':
                  item +=
                    '<span><svg width="12" height="12" viewBox="0 0 12 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M4 2v1h7V2H4zM1 3h1V2H1v1zm3 3h7V5H4v1zM1 6h1V5H1v1zm3 3h7V8H4v1zM1 9h1V8H1v1z"></path></svg></span>';
                  break;

                case 'Product List':
                case 'Related Products':
                case 'Article List':
                  item +=
                    '<span><svg width="12" height="12" viewBox="0 0 12 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M5.995 6.38c-1.15 0-2.24-.164-3.07-.464A3.748 3.748 0 0 1 2 5.446V6.56C2 7.354 3.788 8 5.995 8 8.2 8 9.99 7.355 9.99 6.56V5.45a3.8 3.8 0 0 1-.925.465c-.83.3-1.92.465-3.07.465zm0 3.003c-1.15 0-2.24-.164-3.07-.465A3.747 3.747 0 0 1 2 8.452v1.11C2 10.354 3.788 11 5.995 11 8.2 11 9.99 10.355 9.99 9.56V8.453a3.765 3.765 0 0 1-.925.466c-.83.3-1.92.464-3.07.464zm0-8.383C3.788 1 2 1.645 2 2.44v1.12C2 4.358 3.788 5 5.995 5 8.2 5 9.99 4.357 9.99 3.56V2.44C9.99 1.645 8.2 1 5.995 1z"></path></svg></span>';
                  break;

                case 'Youtube':
                case 'Vimeo':
                case 'Video Popup':
                case 'Vide Bg':
                  item +=
                    '<span><svg width="12" height="12" viewBox="0 0 12 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M8 7.25V6c0-.55-.45-1-1-1H2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V8.75L11 11V5L8 7.25zM2.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm4 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"></path></svg></span>';
                  break;

                case 'Newsletter':
                case 'Contact Form':
                case 'Mailchimp':
                  item +=
                    '<span><svg width="10" height="10" viewBox="0 0 10 10" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" fill-rule="evenodd" d="M9 1H1v1h8V1zM0 0v3h10V0H0zm0 8h5v2H0V8zm1-3h8v1H1V5zM0 7V4h10v3H0z"></path></svg></span>';
                  break;

                case 'Carousel':
                case '(P) Image List':
                  item +=
                    '<svg width="12" height="12" viewBox="0 0 12 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M10.2 1H1.8c-.44 0-.8.36-.8.8v8.4c0 .44.36.8.8.8h8.4c.44 0 .8-.36.8-.8V1.8c0-.44-.36-.8-.8-.8zM3 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1-4L2 4.5 4 3v3zm2 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 6V3l2 1.5L8 6z"></path></svg>';
                  break;

                default:
                  item +=
                    '<svg width="12" height="12" viewBox="0 0 12 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M10.2 1H1.8c-.44 0-.8.36-.8.8v8.4c0 .44.36.8.8.8h8.4c.44 0 .8-.36.8-.8V1.8c0-.44-.36-.8-.8-.8zM6 2h1v1H6V2zM4 2h1v1H4V2zM2 2h1v1H2V2zm8 2.554V10H2V4h8v.554z"></path></svg>';
                  break;
              }
              break;

            case 'element-wrap':
              switch (parents[p].label) {
                case 'Heading':
                  item +=
                    '<span><svg width="12" height="12" viewBox="0 0 12 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M6 5H3V2H2v7h1V6h3v3h1V2H6v3zm3-3a1 1 0 0 0-1 1v1h1v5h1V2H9z"></path></svg></span>';
                  break;

                case 'Text Block':
                  item +=
                    '<span><svg width="12" height="12" viewBox="0 0 12 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M5 8h1V4H5v1H4V3h5v2H8V4H7v4h1v1H5V8z"></path><path fill="currentColor" d="M11 2v8H2V2h9m1-1H1v10h11V1z"></path></svg></span>';
                  break;

                case 'Button':
                case 'Submit Button':
                  item +=
                    '<span><svg width="12" height="12" viewBox="0 0 12 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M1 6.688l.707-.93s1.553.93 2.303 1.617V1H5v4.03h1.01V2H7v3.03h1.01V3H9v2.03h1.01V4l.99.03V6s.312 5-2.562 5H5.573C3.447 11 2.937 7.812 1 6.688z"></path></svg></span>';
                  break;

                case 'Image':
                  item +=
                    '<span><svg width="12" height="12" viewBox="0 0 12 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M10.2 1H1.8c-.44 0-.8.36-.8.8v8.4c0 .44.36.8.8.8h8.4c.44 0 .8-.36.8-.8V1.8c0-.44-.36-.8-.8-.8zM4.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM2 10l5.584-4L10 10H2z"></path></svg></span>';
                  break;

                case 'Dropdown':
                  item +=
                    '<span><svg width="12" height="12" viewBox="0 0 12 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M10.2 1H1.8c-.44 0-.8.36-.8.8v8.4c0 .44.36.8.8.8h8.4c.44 0 .8-.36.8-.8V1.8c0-.44-.36-.8-.8-.8zM6 8L3 5h6L6 8z"></path></svg></span>';
                  break;

                default:
                  break;
              }
              break;

            default:
              item +=
                '<svg width="12" height="12" viewBox="0 0 12 12" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M10.2 1H1.8c-.44 0-.8.36-.8.8v8.4c0 .44.36.8.8.8h8.4c.44 0 .8-.36.8-.8V1.8c0-.44-.36-.8-.8-.8zM6 2h1v1H6V2zM4 2h1v1H4V2zM2 2h1v1H2V2zm8 2.554V10H2V4h8v.554z"></path></svg>';
              break;
          }
          item += '<span class="gf_c-text">' + parents[p].label + '</span>';
          item += '</div>';
          item += '</div>';

          item += '</div>';
        }
        item += '</div>';
        item += '</div>';
      }

      item += '</div>';
      item += '</div>';

      item += '<div class="gf_c-section">';
      item += _this.buildMenuItem('Open Settings', 'settings');
      item += '</div>';

      item += '<div class="gf_c-section">';
      for (let k = 0; k < menuArray.length; k++) {
        const name = menuArray[k].name != undefined ? menuArray[k].name : 'Unknown';
        const action = menuArray[k].action != undefined ? menuArray[k].action : 'Unknown';
        const shortcut = menuArray[k].shortcut != undefined ? menuArray[k].shortcut : '';
        const disabled = menuArray[k].disabled != undefined ? menuArray[k].disabled : false;
        const sections = menuArray[k].sections != undefined ? menuArray[k].sections : false;

        item += _this.buildMenuItem(name, action, shortcut, disabled, sections);
      }
      item += _this.buildMenuItem('Duplicate', 'clone');
      item += _this.buildMenuItem('Delete', 'delete', '&#9003;');
      item += '</div>';

      item += '<div class="gf_c-section">';
      item += '<div class="gf_c-item">';
      item += '<span class="gf_c-text">Move to...</span>';
      item +=
        '<div class="gf_c-caret" style="display: flex; align-items: center;"><svg width="6" height="9" viewBox="0 0 6 9" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M5 4.5L1 8V1z"></path></svg></div>';

      item += '<div class="gf_context-menu">';
      item += '<div class="gf_c-section" data-key="parents">';
      item += '<div class="gf_c-item' + (_atTheTop ? ' gf_c-item-disabled' : '') + '" data-action="moveup">';
      item += '<span class="gf_c-text">Move Up</span>';
      item += '</div>';

      item += '<div class="gf_c-item' + (_atTheBottom ? ' gf_c-item-disabled' : '') + '" data-action="movedown">';
      item += '<span class="gf_c-text">Move Down</span>';
      item += '</div>';

      item += '<div class="gf_c-item' + (!_hasParent ? ' gf_c-item-disabled' : '') + '" data-action="toparent">';
      item += '<span class="gf_c-text">Move to Parent</span>';
      item += '</div>';
      item += '</div>';
      item += '</div>';
      item += '</div>';
      item += '</div>';

      // Interactions

      const interactionsChoosen = this.getInteractions($_targetMER.attr('data-label'));
      if (interactionsChoosen && interactionsChoosen.length) {
        item += '<div class="gf_c-section" gf-section="interaction">';
        item += '<div class="gf_c-item">';
        item += '<span class="gf_c-text">Add Animation</span>';
        item +=
          '<div class="gf_c-caret" style="display: flex; align-items: center;"><svg width="6" height="9" viewBox="0 0 6 9" class="bem-Svg " style="display: block; transform: translate(0px, 0px);"><path fill="currentColor" d="M5 4.5L1 8V1z"></path></svg></div>';

        item += '<div class="gf_context-menu">';
        item += '<div class="gf_c-section" data-key="parents">';
        interactionsChoosen.forEach((e) => {
          item += '<div class="gf_c-item" data-key="' + e.key + '" data-action="addinteraction">';
          item += '<span class="gf_c-text">' + e.name + '</span>';
          item += '</div>';
        });
        item += '</div>';
        item += '</div>';
        item += '</div>';
        item += '</div>';
      }
      item += '<div class="gf_c-section">';
      item += _this.buildMenuItem('Open Flow Actions', 'open_action');
      item += '</div>';

      item += '<div class="gf_c-section">';
      item += '<div class="gf_c-item" data-action="export">';
      item += '<span class="gf_c-text">Save to Library</span>';
      item += '</div>';
      item += '</div>';

      $_gfContextMenu.html(item);

      callback();
      return true;
    };

    /**
     * Get interactions of atom
     * @param atomLabel string
     * @returns array of interactions
     */
    this.getInteractions = function (atomLabel) {
      const atomL1 = _atomLevel1.get(atomLabel);
      if (atomL1) {
        return _interactions.filter((e) => e.type == 'level1');
      }

      const atomL2 = _atomLevel2.get(atomLabel);
      if (atomL2) {
        return _interactions.filter((e) => e.type == 'level2');
      }

      return [];
    };

    this.openMenu = function () {
      window._isContextOpenned = true;
      $_gfContextMenu.addClass(this.settings.activeClass);

      $gryffBody.off('mousedown.right').on('mousedown.right', function (e) {
        const $target = jQuery(e.target);
        if ($target.closest('.gf_context-menu').length == 0) {
          _this.closeMenu();

          $gryffBody.off('mousedown.right');
        }
      });
      return true;
    };
    this.closeMenu = function () {
      window._isContextOpenned = false;

      if ($_targetMER) {
        if ($_targetMER.data('gfelement') != undefined) {
          $_targetMER.data('gfelement').hideTool(true);
        } else if ($_targetMER.data('gfmodule') != undefined) {
          $_targetMER.data('gfmodule').hideTool(true);
        } else if ($_targetMER.data('gfrow') != undefined) {
          $_targetMER.data('gfrow').hideTool(true);
        }
      }

      if ($_gfContextMenu != undefined) {
        $_gfContextMenu.removeClass(this.settings.activeClass);
      }

      // reset target mer
      $_targetMER = undefined;

      return true;
    };

    this.applyEvents = function () {};

    this.getTargetMERId = function () {
      if ($_targetMER) {
        return $_targetMER.attr('id');
      }
      return null;
    };

    this.getClipBoardCSS = function () {
      return store.getValue('__clipBoardCSS') || {};
    };

    this.init();
  };
  jQuery.fn.gfContextMenu = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfcontextmenu')) {
        const plugin = new jQuery.gfContextMenu(this, options);
        jQuery(this).data('gfcontextmenu', plugin);
      }
    });
  };
})(jQuery);
